module.exports = __webpack_public_path__ + "static/media/photoshop.5ef88fc6.png";